import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <h2 className="text-sm font-semibold text-foreground-500 uppercase tracking-widest mb-3">
              Shop by
            </h2>
            <h3 className="text-4xl md:text-5xl font-heading italic text-foreground-950">
              Category
            </h3>
          </div>
          <p className="text-foreground-600 text-sm max-w-md leading-relaxed">
            Browse through our carefully organized product categories. Each category links directly to the full product listings on our main spreadsheet store — find exactly what you need in seconds.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full h-56 overflow-hidden bg-background-100">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {/* Category Tag */}
                <span className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-accent-200 text-foreground-900 text-xs font-semibold">
                  {cat.name}
                </span>
              </div>

              {/* Content */}
              <div className="p-5">
                <h4 className="text-lg font-bold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-accent-600 text-sm font-medium">
                  <span>Browse Collection</span>
                  <i className="ri-arrow-right-up-line"></i>
                </div>
              </div>
            </a>
          ))}

          {/* Visual Anchor Card - replaces one grid spot */}
          <div className="rounded-2xl bg-primary-500 flex flex-col items-center justify-center p-10 text-center min-h-[380px]">
            <div className="w-16 h-16 rounded-full bg-accent-400/30 flex items-center justify-center mb-5">
              <i className="ri-store-2-line text-3xl text-background-50"></i>
            </div>
            <h4 className="text-2xl font-heading font-bold text-background-50 mb-3">
              100+ Products
            </h4>
            <p className="text-background-50/70 text-sm leading-relaxed mb-6">
              All available through the OOPBuy spreadsheet system with transparent pricing
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 hover:bg-background-100 transition-colors text-foreground-950 font-semibold text-sm whitespace-nowrap cursor-pointer"
            >
              Visit Store
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}